import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import FormCollection from 'components/Form/Collection'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import Textarea from 'components/Form/Textarea'

import { guid } from 'helpers/index'
import { stateOptions, makeOptions } from 'helpers/components'
import { disallowedISOWeekdays } from 'helpers/moment'

import classes from './Form.scss'

const dayOfWeekOptions = [
  // NOTE: This is filtered out by
  { value: '*', label: 'Default' },
  { value: '1', label: 'Monday' },
  { value: '2', label: 'Tuesday' },
  { value: '3', label: 'Wednesday' },
  { value: '4', label: 'Thursday' },
  { value: '5', label: 'Friday' },
  { value: '6', label: 'Saturday' },
  { value: '7', label: 'Sunday' }
].filter(obj => !disallowedISOWeekdays.includes(Number(obj.value)))

export class CustomerForm extends React.Component {
  constructor (props) {
    super(props)

    this.submitInputId = `submit-${guid()}`
  }

  render () {
    return <form onSubmit={this.props.handleSubmit} className={classes['form']}>
      <input type='submit' id={this.submitInputId} className={classes.hidden} />

      <header className={classes['header']}>
        <div className={classes['header-title']}>
          {this.props.editing && 'Editing' || 'Add'} a Customer
        </div>

        {this.props.editing && <div className={classes['header-buttons']}>
          <Button confirm options={['red', 'small']} callback={() => this.props.handleDelete(this.props.customer.id)}>
            Delete
          </Button>
        </div>}
      </header>

      <fieldset>
        <Input label='Customer Name' placeholder='restaurant or company' {...this.props.fields.name} />
        <Textarea label='Customer Notes' placeholder='Notes displayed during order creation.' {...this.props.fields.notes} />

        <FormCollection
          label='Automatic Routing'
          collection={this.props.fields.routes}
          defaultModel={{ day_of_week: undefined, id: undefined }}
          fields={[
            { name: 'day_of_week', element: 'select', selectOptions: dayOfWeekOptions, placeholder: 'select day of week' },
            {
              name: 'id',
              element: 'select',
              selectOptions: makeOptions(this.props.routes, 'id', 'name', { sort: false }),
              placeholder: 'add a spec'
            }
          ]}
        />
      </fieldset>

      <fieldset>
        <div className={classes['legend--center']}>Contact Details</div>
        <Input label='Order Confirmation Emails' note='Separate multiple emails by commas.' placeholder='email@example.com'
          {...this.props.fields.cc_orders} />

        <FormCollection
          label='Contacts'
          collection={this.props.fields.contacts}
          defaultModel={{ title: undefined, name: undefined, phone_number: undefined, email: undefined }}
          fields={[
            { name: 'title', placeholder: 'contact title' },
            { name: 'name', placeholder: 'contact name' },
            { name: 'phone_number', placeholder: 'contact phone' },
            { name: 'email', type: 'email', placeholder: 'contact email' }
          ]}
        />
      </fieldset>

      <fieldset>
        <div className={classes['legend--center']}>Address / Delivery</div>
        <Input label='Address' placeholder='address or delivery notes' {...this.props.fields.address} />

        <div className={classes['city-state-zip']}>
          <Input label='City' placeholder='city' {...this.props.fields.city} />

          <Select label='State' placeholder='select state' options={['expandable--tiny', 'expandable--small']}
            selectOptions={stateOptions}
            {...this.props.fields.state}
          />

          <Input label='Zip Code' placeholder='zip code' {...this.props.fields.postcode} />
        </div>
      </fieldset>

      <footer className={classes['footer']}>
        <Button element={'label'} htmlFor={this.submitInputId} stick options={['green', 'block']}>
          {this.props.editing && 'Update Customer' || 'Create Customer'}
        </Button>
      </footer>
    </form>
  }
}

CustomerForm.propTypes = {
  customer: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,

  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  editing: PropTypes.bool
}

CustomerForm.defaultProps = {
  editing: false
}

export default CustomerForm



// WEBPACK FOOTER //
// ./src/components/Customers/Form/CustomerForm.js